import axios from "axios";

const appUrl = process.env.MIX_APP_URL;

const chapterService = {
  async getArtists(choice) {
    return  axios
        .post(appUrl + '/api/chapters/get-artists/?choice=' + choice)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async getChaptersByAudioBookId(audioBookId) {
    return  axios
        .get(appUrl + '/api/chapters/audio-book-id/' + audioBookId)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async addChapter(data) {
    return  axios
        .post(appUrl + '/api/chapters/', data)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async updateChapter(data) {
    return  axios
        .put(appUrl + '/api/chapters/', data)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async updateChapterName(data) {
    return  axios
        .post(appUrl + '/api/chapters/update-name', data)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async getChapterById(id) {
    return  axios
        .get(appUrl + '/api/chapters/' + id)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async getMixedChapters(data) {
    return  axios
        .patch(appUrl + '/api/chapters/mix', data)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async addTimestamps(data) {
    return  axios
        .patch(appUrl + '/api/chapters/timestamps', data)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async deleteAudio(data) {
    return  axios
        .patch(appUrl + '/api/chapters/delete-audio', data)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async delete(id) {
    return  axios
        .delete(appUrl + '/api/chapters/' + id)
        .catch(err => console.log(err));
  },
  async addAudio(data) {
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    }

    return  axios
        .patch(appUrl + '/api/chapters/audio', data, config)
        .then(response => response.data)
        .catch(err => console.log(err));
  }
};

export default chapterService;
